import {findIndex, PartialShallow, pick} from 'lodash';
import {Vue} from 'vue-property-decorator';

export const mergeAndAdd = <T = Record<string, any>>(existingItems: T[], newItems: T | T[], predicateKeys: (keyof T)[]) => {
	if(!Array.isArray(newItems)) {
		newItems = [newItems];
	}
	newItems.forEach((newItem) => {
		const existingItemIndex = findIndex(existingItems, pick(newItem, predicateKeys) as PartialShallow<T>);
		if(existingItemIndex > -1) {
			Vue.set(existingItems, existingItemIndex, Object.assign({}, existingItems[existingItemIndex], newItem));
		} else {
			existingItems.push(newItem);
		}
	});
};
